import { s as subscribe } from "./utils.js";
import { c as create_ssr_component, d as add_attribute, v as validate_component, i as each, e as escape } from "./ssr.js";
import { I as Input } from "./Input.js";
import { S as Search } from "./Search.js";
import { twMerge } from "tailwind-merge";
import { L as Listgroup, a as ListgroupItem } from "./Listgroup.js";
import { M as Modal } from "./Modal2.js";
import "./api.js";
import "./client.js";
import { p as page } from "./stores.js";
const Kbd = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { kbdClass = "text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg dark:bg-gray-600 dark:text-gray-100 dark:border-gray-500" } = $$props;
  if ($$props.kbdClass === void 0 && $$bindings.kbdClass && kbdClass !== void 0) $$bindings.kbdClass(kbdClass);
  return `<kbd${add_attribute("class", twMerge(kbdClass, $$props.class), 0)}>${slots.default ? slots.default({}) : ``}</kbd> `;
});
const GlobalShortcuts = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let openSearch = false;
  let openID = false;
  let searchTerm = "";
  let searchResults = {};
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = ` ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        title: "Mitarbeiter ID " + ($page.data?.employee?.id ? "(" + $page.data?.employee?.id + ")" : ""),
        open: openID
      },
      {
        open: ($$value) => {
          openID = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<form>${validate_component(Input, "Input").$$render(
            $$result,
            {
              id: "id-search",
              type: "number",
              value: searchTerm
            },
            {
              value: ($$value) => {
                searchTerm = $$value;
                $$settled = false;
              }
            },
            {}
          )}</form>`;
        }
      }
    )} ${validate_component(Modal, "Modal").$$render(
      $$result,
      {
        title: "Mitarbeiter Suche",
        open: openSearch
      },
      {
        open: ($$value) => {
          openSearch = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${validate_component(Search, "Search").$$render(
            $$result,
            {
              id: "global-searchbox",
              placeholder: "Mitarbeiter",
              value: searchTerm
            },
            {
              value: ($$value) => {
                searchTerm = $$value;
                $$settled = false;
              }
            },
            {}
          )} ${searchResults?.collection?.length > 0 ? `${validate_component(Listgroup, "Listgroup").$$render($$result, { active: true }, {}, {
            default: () => {
              return `${each(searchResults.collection, (item, i) => {
                return `${validate_component(ListgroupItem, "ListgroupItem").$$render($$result, {}, {}, {
                  default: () => {
                    return `<a class="flex-1" href="${"/employee/" + escape(item.uuid, true)}">${validate_component(Kbd, "Kbd").$$render($$result, { class: "px-2 py-1.5" }, {}, {
                      default: () => {
                        return `Alt`;
                      }
                    })} + ${validate_component(Kbd, "Kbd").$$render($$result, { class: "px-2 py-1.5" }, {}, {
                      default: () => {
                        return `${escape(i + 1)}`;
                      }
                    })} ${escape(item.name)}</a> `;
                  }
                })}`;
              })}`;
            }
          })}` : ``}`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_page();
  return $$rendered;
});
export {
  GlobalShortcuts as G
};
//# sourceMappingURL=GlobalShortcuts.js.map
